module.exports = __webpack_public_path__ + "static/media/autoroute.23136892.svg";